<template>
  <sdPageHeader :title="title"> </sdPageHeader>
  <Main>
    <HorizontalFormStyleWrap>
      <sdCards headless>
        <a-form
          layout="horizontal"
          :model="formState"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          labelAlign="left"
          :rules="rules"
          @finish="handleSubmit"
        >
          <a-form-item name="kpi_korporat_id" label="Indikator Kinerja">
            <a-select
              placeholder="Pilih Indikator Kinerja"
              v-model:value="formState.kpi_korporat_id"
              show-search
              :filter-option="filterSelect"
              @change="changeKpiKorporat"
              :disabled="mode == 'Ubah' ? true : false"
              v-if="mode == 'Ubah' || mode == 'Tambah'"
            >
              <a-select-option v-for="option in options.kpiKorporat" :key="option.value">
                {{ option.text }}
              </a-select-option>
            </a-select>
            <span v-if="mode == 'Detail'">{{ formState.name }}</span>
          </a-form-item>
          <a-form-item name="month" label="Bulan">
            <a-select
              placeholder="Pilih Bulan"
              v-model:value="formState.month"
              show-search
              :filter-option="filterSelect"
              :disabled="mode == 'Ubah' ? true : false"
              v-if="mode == 'Ubah' || mode == 'Tambah'"
            >
              <template v-if="!kpiKorporat.data.is_akumulasi">
                <a-select-option v-for="option in options.month" :key="option.value">
                  {{ option.text }}
                </a-select-option>
              </template>

              <template v-else>
                <a-select-option v-for="option in options.month2" :key="option.value">
                  {{ option.text }}
                </a-select-option>
              </template>
            </a-select>
            <span v-if="mode == 'Detail'">{{ formState.monthName }}</span>
          </a-form-item>
          <template v-if="kpiKorporat.data.jenis_variable_kpi_id != 2 && kpiKorporat.data.jenis_variable_kpi_id != 4">
            <a-form-item
              name="target_nominal"
              label="Target"
              v-if="kpiKorporat.data.polarisasi != 'Rentang' && kpiKorporat.data.polarisasi != 'Rentang 4 Titik'"
            >
              <a-input-number
                v-model:value="formState.target_nominal"
                placeholder="Masukkan Target"
                :disabled="isRealisasi"
                v-if="mode == 'Ubah' || mode == 'Tambah'"
              />
              <span v-if="mode == 'Detail'">{{ formState.target_nominal }}</span>
            </a-form-item>

            <a-form-item
              name="target_nominal"
              label="Target Min"
              v-if="kpiKorporat.data.polarisasi == 'Rentang' || kpiKorporat.data.polarisasi == 'Rentang 4 Titik'"
            >
              <a-input-number
                v-model:value="formState.target_nominal"
                placeholder="Masukkan Target Min"
                :disabled="isRealisasi"
                v-if="mode == 'Ubah' || mode == 'Tambah'"
              />
            </a-form-item>

            <a-form-item
              name="target_nominal_max"
              label="Target Max"
              v-if="kpiKorporat.data.polarisasi == 'Rentang' || kpiKorporat.data.polarisasi == 'Rentang 4 Titik'"
            >
              <a-input-number
                v-model:value="formState.target_nominal_max"
                placeholder="Masukkan Target Max"
                :disabled="isRealisasi"
                v-if="mode == 'Ubah' || mode == 'Tambah'"
              />
            </a-form-item>

            <a-form-item name="batas_max" label="Batas Max" v-if="kpiKorporat.data.polarisasi == 'Rentang 4 Titik'">
              <a-input-number
                v-model:value="formState.batas_max"
                placeholder="Masukkan Batas Max"
                :disabled="isRealisasi"
                v-if="mode == 'Ubah' || mode == 'Tambah'"
              />
            </a-form-item>
          </template>

          <a-form-item name="target_manual" label="Target" v-if="kpiKorporat.data.jenis_variable_kpi_id == 4">
            <a-textarea
              :disabled="isRealisasi"
              v-model:value="formState.target_manual"
              :auto-size="{ minRows: 3, maxRows: 6 }"
              placeholder="Masukkan Target"
            />
          </a-form-item>

          <a-form-item name="target_waktu" label="Target" v-if="kpiKorporat.data.jenis_variable_kpi_id == 2">
            <a-month-picker
              v-model:value="formState.target_waktu"
              placeholder="Pilih Target"
              format="MM-YYYY"
              valueFormat="YYYY-MM"
              :disabled="isRealisasi"
              v-if="mode == 'Ubah' || mode == 'Tambah'"
            />
            <span v-if="mode == 'Detail'">{{ formState.target_waktu }}</span>
          </a-form-item>
          <template v-if="mode == 'Ubah' || mode == 'Detail'">
            <a-form-item name="status" label="Status">
              <a-tag :color="formState.dataColor">{{ formState.statusKpi }}</a-tag>
            </a-form-item>
          </template>
          <template v-if="(mode == 'Ubah' || mode == 'Detail') && formState.statusKpi == 'UNREL'">
            <a-form-item name="alasan" label="Alasan">
              <span>{{ formState.alasan }}</span>
            </a-form-item>
          </template>
          <a-row>
            <a-col :lg="{ span: 18, offset: 6 }" :md="{ span: 15, offset: 9 }" :xs="{ span: 24, offset: 0 }">
              <div class="sDash_form-action" v-if="mode == 'Ubah' || mode == 'Tambah'">
                <sdButton class="sDash_form-action__btn" type="primary" size="large" htmlType="submit">
                  {{ isLoading ? 'Harap Menunggu...' : mode }}
                </sdButton>

                <router-link v-if="mode == 'Tambah'" :to="'/nko/kontrak'">
                  <sdButton class="sDash_form-action__btn" type="light" size="large" htmlType="button">
                    Batal
                  </sdButton>
                </router-link>

                <router-link v-else :to="'/nko/kontrak'">
                  <sdButton class="sDash_form-action__btn" type="light" size="large" htmlType="button">
                    Batal
                  </sdButton>
                </router-link>
              </div>
              <div class="sDash_form-action" v-else>
                <sdButton
                  class="sDash_form-action__btn"
                  type="primary"
                  size="large"
                  htmlType="button"
                  v-if="checkPermission('approve kpi korporat') && formState.statusKpi != 'REL'"
                  @click="handleApprove(formState.id, formState.month, formState.year, 'target')"
                >
                  {{ isLoading ? 'Harap Menunggu...' : 'Approve' }}
                </sdButton>

                <sdButton
                  class="sDash_form-action__btn"
                  type="primary"
                  size="large"
                  htmlType="button"
                  v-if="checkPermission('approve kpi korporat') && formState.statusKpi == 'REL'"
                  @click="handleUnapprove(formState.id, formState.month, formState.year, 'target')"
                >
                  {{ isLoading ? 'Harap Menunggu...' : 'Unapprove' }}
                </sdButton>

                <router-link :to="'/nko/kontrak'">
                  <sdButton class="sDash_form-action__btn" type="light" size="large" htmlType="button">
                    Kembali
                  </sdButton>
                </router-link>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </sdCards>
    </HorizontalFormStyleWrap>
  </Main>
</template>

<script>
import { HorizontalFormStyleWrap } from '../../../components/crud/style';
import { Main } from '../../styled';
import { useStore } from 'vuex';
import { reactive, computed, onMounted, toRaw, ref } from 'vue';
import { useRoute } from 'vue-router';
import { getItem } from '@/utility/localStorageControl';
import { Modal } from 'ant-design-vue';
import { DataService } from '@/config/dataService/dataService';
import { notification } from 'ant-design-vue';

const TargetKpiKorporatForm = {
  name: 'TargetKpiKorporatForm',
  components: { HorizontalFormStyleWrap, Main },
  data() {
    return {
      title: this.mode + ' ' + this.module,
    };
  },
  props: ['mode', 'module'],
  setup(props) {
    const { state, dispatch } = useStore();
    const { params } = useRoute();
    const isLoading = computed(() => state.crud.loading);
    const crud = computed(() => state.crud.data);
    const profile = getItem('profile_plnbb');
    const permissions = getItem('permissions');
    const months = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const isRealisasi = ref(false);
    const formState = reactive({
      kpi_korporat_id: undefined,
      month: null,
      year: null,
      targets: [],
      target_nominal: null,
      target_nominal_max: null,
      batas_max: null,
      target_waktu: '',
      name: '',
      monthName: '',
      statusKpi: null,
      dataColor: '',
      alasan: '',
    });

    const dateState = reactive({
      month: params.month,
      year: params.year,
    });

    const modalState = reactive({
      isLoading: false,
      visible: false,
      kpi_korporat: '',
      month: '',
      year: null,
      type: '',
    });

    const formModalState = reactive({
      id: null,
      alasan: '',
    });

    const options = reactive({
      kpiKorporat: [],
      month: [
        { value: 1, text: 'Januari' },
        { value: 2, text: 's.d. Februari' },
        { value: 3, text: 's.d. Maret' },
        { value: 4, text: 's.d. April' },
        { value: 5, text: 's.d. Mei' },
        { value: 6, text: 's.d. Juni' },
        { value: 7, text: 's.d. Juli' },
        { value: 8, text: 's.d. Agustus' },
        { value: 9, text: 's.d. September' },
        { value: 10, text: 's.d. Oktober' },
        { value: 11, text: 's.d. November' },
        { value: 12, text: 's.d. Desember' },
      ],
      month2: [
        { value: 1, text: 'Januari' },
        { value: 2, text: 'Februari' },
        { value: 3, text: 'Maret' },
        { value: 4, text: 'April' },
        { value: 5, text: 'Mei' },
        { value: 6, text: 'Juni' },
        { value: 7, text: 'Juli' },
        { value: 8, text: 'Agustus' },
        { value: 9, text: 'September' },
        { value: 10, text: 'Oktober' },
        { value: 11, text: 'November' },
        { value: 12, text: 'Desember' },
      ],
    });

    const kpiKorporat = reactive({
      data: {},
    });

    const labelCol = {
      lg: 6,
      md: 9,
      xs: 24,
    };

    const wrapperCol = {
      lg: 18,
      md: 15,
      xs: 24,
    };

    const handleSubmit = values => {
      const postData = toRaw(formState);

      if (values.target_waktu) {
        let my = values.target_waktu.split('-');
        postData['target_waktu'] = my[0] + '-' + my[1] + '-' + '01';
      }

      if (props.mode == 'Tambah') {
        dispatch('axiosCrudSubmitDataRedirect', {
          url: 'target-kpi-korporat',
          data: postData,
          redirect: '/nko/kontrak',
        });
      } else if (props.mode == 'Ubah') {
        dispatch('axiosDataUpdateRedirect', {
          id: params.id,
          url: 'target-kpi-korporat',
          data: postData,
          redirect: '/nko/kontrak',
        });
      }
    };

    const rules = {
      kpi_korporat_id: [
        {
          required: true,
          message: 'Harap Dipilih',
          trigger: 'blur',
          type: 'number',
        },
      ],
      month: [
        {
          required: true,
          message: 'Harap Dipilih',
          trigger: 'blur',
          type: 'number',
        },
      ],
    };

    const filterSelect = (input, option) => {
      return option.children[0].children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    };

    const changeKpiKorporat = value => {
      dispatch('axiosCrudGetData', 'kpi-korporat/' + value).then(() => {
        kpiKorporat.data = crud.value.data;
      });
    };

    onMounted(() => {
      getData();
    });

    const getData = async () => {
      try {
        // Fetch KPI Korporat options
        await dispatch('axiosCrudGetData', 'options-kpi-korporat');
        options.kpiKorporat = crud.value;

        if (props.mode === 'Tambah') {
          formState.kpi_korporat_id = parseInt(params.id);
          formState.month = parseInt(params.month);
          changeKpiKorporat(parseInt(params.id));
          return;
        }

        // Fetch single target data
        const data = { url: 'target-kpi-korporat', id: params.id };
        await dispatch('axiosSingleDataGet', data);
        // Copy properties to formState
        Object.keys(crud.value).forEach(key => {
          formState[key] = crud.value[key];
        });

        formState.name = crud.value.kpi_korporat?.name;
        formState.statusKpi = crud.value.status;
        formState.alasan = crud.value.last_alasan;

        // Set month name based on akumulasi
        const monthList = crud.value.kpi_korporat?.is_akumulasi ? options.month2 : options.month;
        formState.monthName = monthList.find(month => month.value === crud.value.month)?.text || '';
        formState.year = crud.value.kpi_korporat?.year;
        isRealisasi.value = crud.value.is_realisasi;

        // Status color mapping
        const statusColorMap = {
          CRTD: 'blue',
          UPDT: 'orange',
          REL: 'green',
          UNREL: 'volcano',
          DEL: 'red',
        };
        formState.dataColor = statusColorMap[crud.value.status] || '';

        // Fetch KPI Korporat detail
        await dispatch('axiosCrudGetData', 'kpi-korporat/' + crud.value.kpi_korporat_id);
        kpiKorporat.data = crud.value.data;

        // If not breakdown, skip target variables
        if (!crud.value.data?.is_breakdown_target) return;

        // Fetch and process target variables
        const endpoint = `target-variables-by-kpi-korporat?kpi_korporat_id=${crud.value.data.id}&month=${formState.month}`;
        await dispatch('axiosCrudGetData', endpoint);
        const jenisVar = crud.value.data?.jenis_variable_kpi_id;
        (crud.value.data || []).forEach(data => {
          const targetValue = jenisVar === 2 ? data.target_waktu : data.target_nominal;
          formState.targets[data.variable_kpi_korporat_id] = targetValue;
        });
      } catch (error) {
        console.error(error);
      }
    };

    const checkPermission = permission => {
      if (profile.roles[0].name == 'Super Admin') {
        return true;
      }

      if (Array.isArray(permission)) {
        return permission.some(p => permissions.includes(p.toLowerCase()));
      }

      return permissions.includes(permission.toLowerCase());
    };

    const modalRules = {
      alasan: [
        {
          required: true,
          message: 'Harap Diisi',
          trigger: 'blur',
        },
      ],
    };

    const handleApprove = (id, month, year, type) => {
      Modal.confirm({
        title: 'Konfirmasi',
        content: `Apakah Anda yakin ingin melakukan approve ${type} ${formState.name} untuk bulan ${months[month]} ${year}?`,
        okText: 'Approve',
        cancelText: 'Batal',
        onOk: () => {
          dispatch('axiosDataApprove', {
            id,
            url: 'approve-' + type + '-kpi-korporat',
            getData: () => {
              getData();
            },
          });
        },
      });
    };

    const handleUnapprove = (id, month, year, type) => {
      getData();
      formModalState.id = id;
      modalState.kpi_korporat = formState.name;
      modalState.month = months[month];
      modalState.year = year;
      modalState.visible = true;
      modalState.type = type;
    };

    const doUnapprove = () => {
      modalState.isLoading = true;

      DataService.post('unapprove-' + modalState.type + '-kpi-korporat/' + formModalState.id, {
        alasan: formModalState.alasan,
      }).then(response => {
        modalState.visible = false;
        modalState.isLoading = false;
        formModalState.id = null;
        formModalState.alasan = '';

        notification.success({
          message: response.data.message,
        });

        getData();
      });
    };

    return {
      formState,
      labelCol,
      wrapperCol,
      handleSubmit,
      isLoading,
      rules,
      options,
      filterSelect,
      changeKpiKorporat,
      kpiKorporat,
      dateState,
      checkPermission,
      modalState,
      formModalState,
      modalRules,
      handleApprove,
      handleUnapprove,
      doUnapprove,
      isRealisasi,
    };
  },
};

export default TargetKpiKorporatForm;
</script>
